<!--
  产品选择组件
  props:
    select: 已选产品数据
    moduleName： 模块名
    decimalPrecisionMap: 产品相关精度
  emit:
    emitProductsData: 要提交的关联产品数据
 -->

<template>
  <div class="v-products">
    <el-dialog title="退货关联产品" :visible.sync="dialogVisible" :modal="false" :before-close="closeDialog" custom-class="product-new">
      <el-table
        ref="table"
        :data="productList"
        border
        style="width: 100%"
        @select-all="handleSelect"
        @select="handleSelect">
        <el-table-column
          type="selection"
          width="38">
        </el-table-column>

        <el-table-column
          prop="productName"
          label="产品名称"
          :show-overflow-tooltip="true">
        </el-table-column>

        <el-table-column
          prop="productNo"
          label="产品编号"
          :show-overflow-tooltip="true">
        </el-table-column>

        <el-table-column
          width="70"
          prop="specification"
          label="规格"
          :show-overflow-tooltip="true">
        </el-table-column>

        <el-table-column
          width="70"
          prop="priceStr"
          label="单价"
          :show-overflow-tooltip="true">
        </el-table-column>

        <el-table-column
          width="148"
          label="数量">
          <template slot-scope="scope">
            <el-input-number size="small" v-model="scope.row.num" :min="0" :max="scope.row.stock" :debounce="1000" @change="handleNumChange(scope.$index, scope.row.id)"></el-input-number>
          </template>
        </el-table-column>
        <el-table-column
          width="200"
          label="备注">
          <template slot-scope="scope">
            <el-input type="textarea" :autosize="{minRows: 1, maxRows: 3}" v-model="scope.row.memo" @change="handleNumChange(scope.$index, scope.row.id)"></el-input>
          </template>
        </el-table-column>

        <el-table-column
          width="50"
          prop="unit"
          label="单位">
        </el-table-column>
      </el-table>

      <div class="pagination-wrapper" v-show="total > productList.length">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
      <div slot="footer" class="dialog-footer">
        <span class="select">已选产品：{{selectProducts.length}}</span>
        <el-button type="primary"  @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as api from 'src/api'
import * as utils from 'src/utils'
import { Message } from 'element-ui'

export default {
  created () {
    this.selectProducts = JSON.parse(JSON.stringify(this.select)) || []
    this.selectProductArr[0] = JSON.parse(JSON.stringify(this.select)) || []
    this.getProducts()
  },
  props: {
    select: {
      required: true,
      default: () => []
    },
    decimalPrecisionMap: {
      type: Object
    },
    contractId: Object
  },
  data () {
    return {
      dialogVisible: false,
      currentPage: 1,
      total: 0,
      pageSize: 6,
      productList: [], // 所有产品列表
      selectProducts: [], // 已选产品
      totalMoney: 0,       //  选择的产品的总钱数
      selectProductArr: [] // 已选产品的二维数组
    }
  },

  computed: {
    idArr () {
      if (this.selectProducts) {
        return this.selectProducts.map(item => item.id)
      } else {
        return []
      }
    }
  },

  methods: {
    // 选中事件
    handleSelect (selection) {
      this.selectProductArr[this.currentPage] = JSON.parse(JSON.stringify(selection))
      this.selectProducts = Array.prototype.concat.apply([], this.selectProductArr).filter(item => {
        if (item) {
          return item
        }
      })
      this.countTotalMoney()
    },

    //  计算选中的商品的总价钱
    countTotalMoney () {
      this.totalMoney = 0
      if (this.selectProducts.length) {
        this.selectProducts.forEach((item) => {
          if (!item.price) item.price = 0
          let price = item.price.toString().replace(/,/g, '')
          let money = utils.multiply(item.num, Number(price))
          this.totalMoney = utils.plus(this.totalMoney, money)
        })
      } else {
        this.totalMoney = 0
      }
    },
    // 获取商品信息
    getProducts (key, ids) {
      let url = '/refund/getProduct.html'
      let params = {
        page: this.currentPage,
        pageSize: this.pageSize,
        contractId: this.contractId.id
      }
      api.post(url, params, (data) => {
        this.dialogVisible = true

        // 给异步获取的数据增加库存字段和备注字段
        this.productList = data.productList.map((item) => {
          item.stock = item.num
          item.memo = ''
          return item
        })
        this.total = data.count

        // 是否有已选产品
        this.$nextTick(() => {
          this.selectProductArr[this.currentPage] = []
          this.productList.map((row, index) => {
            const num = this.idArr.indexOf(row.id)
            if (num > -1) {
              row.num = this.selectProducts[num].num  // 更新已选产品的库存数量
              row.memo = this.selectProducts[num].memo // 更新已选产品备注
              this.$refs.table.toggleRowSelection(row)
              this.selectProductArr[this.currentPage].push(row)
              this.selectProductArr[0] = this.selectProductArr[0].filter(item => {
                if (row.id !== item.id) {
                  return item
                }
              })
            }
            return row
          })
        })
      })
    },

    // 每页所显示的条数变更
    handleSizeChange (val) {
      this.pageSize = val
      this.getProducts()
    },

    // 监听库存数量的变化和产品备注变化
    handleNumChange (index, id) {
      this.$nextTick(() => {
        let num = Number(this.productList[index].num.toFixed(this.decimalPrecisionMap['stock']))
        let memo = this.productList[index].memo
        if (this.selectProducts && this.selectProducts.length) {
          this.selectProducts.map(item => {
            if (item.id === id) {
              item.num = num
              item.memo = memo
            }
            // return num
          })
          this.productList[index].num = num
          this.countTotalMoney()
        }
      })
    },

    // 当前分页变更
    handleCurrentChange (val) {
      this.currentPage = val
      this.getProducts()
    },

    // 关闭弹窗
    closeDialog () {
      this.$emit('close')
    },

    // 提交数据
    handleSubmit () {
      this.countTotalMoney()
      // 校验合同产品备注字符不超过200
      let count = 0
      let name = ''
      console.log(434, this.selectProducts)
      this.selectProducts.map((item) => {
        if (item.memo.length > 200) {
          name = item.productName
          count++
        }
      })
      if (count) {
        Message({
          type: 'error',
          message: '产品备注的长度不能超过200个字符:' + name
        })
        return false
      }
      this.$emit('emitProductsData', this.selectProducts, this.totalMoney)
      this.closeDialog()
    }
  }
}
</script>

<style lang="less">
  .v-products {
    .product-new {
      width: 720px;
    }
    .el-dialog__body {
      padding: 10px;
      min-height: 300px;
    }
    .el-dialog__header {
      line-height: 1;
    }
    .dialog-footer {
      line-height: 1;
      position: relative;
      .select {
        position: absolute;
        left: 0;
        top: 4px;
        padding: 6px 15px;
        border-radius: 13px;
      }
    }
    .el-table__body-wrapper {
      overflow-y: auto;
    }
  }
</style>



// WEBPACK FOOTER //
// product-new.vue?01d56afd